import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Services from "./pages/Services";
import About from "./pages/About";
import Careers from "./pages/Careers";
import Contact from "./pages/Contact";
import MyCare from "./pages/MyCare";
import FamilyCaregiver from "./pages/FamilyCaregiver";
import CountyPage from "./pages/CountyPage";
import Refer from "./pages/Refer";
import PrivatePay from "./pages/PrivatePay";
import Dodd from "./pages/Dodd";
import Providers from "./pages/Providers";
import ReferralPartners from "./pages/ReferralPartners";
import ProviderSheet from "./pages/ProviderSheet";
import MobileCtaBar from "./components/MobileCtaBar";
import Dashboard from "./pages/Dashboard";
import ScrollToTop from "./components/ScrollToTop";
import HpcServices from "./pages/HpcServices";
import RespiteCare from "./pages/RespiteCare";
import HomeCareGuide from "./pages/HomeCareGuide";
import { RouteAnalytics } from "./components/RouteAnalytics";

function SiteLayout({ children }) {
  return (
    <>
      <Header />
      <main className="pb-16 md:pb-0">{children}</main>
      <Footer />
      <MobileCtaBar />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <RouteAnalytics />
        <Routes>
          <Route path="/" element={<SiteLayout><Home /></SiteLayout>} />
          <Route path="/services" element={<SiteLayout><Services /></SiteLayout>} />
          <Route path="/about" element={<SiteLayout><About /></SiteLayout>} />
          <Route path="/careers" element={<SiteLayout><Careers /></SiteLayout>} />
          <Route path="/contact" element={<SiteLayout><Contact /></SiteLayout>} />
          <Route path="/mycare" element={<SiteLayout><MyCare /></SiteLayout>} />
          <Route path="/family-caregiver" element={<SiteLayout><FamilyCaregiver /></SiteLayout>} />
          <Route path="/ohio/:slug/home-care" element={<SiteLayout><CountyPage /></SiteLayout>} />
          <Route path="/refer" element={<SiteLayout><Refer /></SiteLayout>} />
          <Route path="/private-pay" element={<SiteLayout><PrivatePay /></SiteLayout>} />
          <Route path="/dodd" element={<SiteLayout><Dodd /></SiteLayout>} />
          <Route path="/hpc" element={<SiteLayout><HpcServices /></SiteLayout>} />
          <Route path="/respite-care" element={<SiteLayout><RespiteCare /></SiteLayout>} />
          <Route path="/how-to-get-home-care-in-ohio" element={<SiteLayout><HomeCareGuide /></SiteLayout>} />
          <Route path="/providers" element={<SiteLayout><Providers /></SiteLayout>} />
          <Route path="/referral-partners" element={<SiteLayout><ReferralPartners /></SiteLayout>} />
          <Route path="/provider-sheet" element={<ProviderSheet />} />
          <Route path="/owner" element={<Dashboard />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
